import { trimObjectValues } from '@/utilz';
import { LADCovertDatesToMomentType } from '@/utilz/PreClaimsUtils';

import type { ClaimDetailsResponse } from './api';

export const normalizeClaimDetails = (data: ClaimDetailsResponse): ClaimDetailsResponse => {
  if (!data) {
    return data;
  }
  return LADCovertDatesToMomentType(trimObjectValues(data));
};
